const FAQHyfye = () => {
  return (
    <section id="faq" className="bg_light_dark">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12 offset-lg-2">
            <div className="text-center faq-header">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Frequently Asked Questions
              </h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Everything you need to know about Hyfye, your gateway to a universal economy of appreciation.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            <div id="accordion" className="faq_content2">

                {/* 1 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingOne">
                  <h6 className="mb-0">
                    <a data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      What is Hyfye?
                    </a>
                  </h6>
                </div>
                <div id="collapseOne" className="collapse show" data-parent="#accordion">
                  <div className="card-body">
                    Hyfye is a universal micro-earning cryptocurrency (HYE) powering a suite of Web3 mini-apps for finance, content, gaming, and wellness.
                  </div>
                </div>
              </div>

              {/* 2 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingTwo">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      How can I earn HYE tokens?
                    </a>
                  </h6>
                </div>
                <div id="collapseTwo" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    You earn HYE tokens by using Hyfye Minis — lightweight decentralized apps. Engage in fitness, finance, content creation, and more to earn from everyday actions.
                  </div>
                </div>
              </div>

              {/* 3 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingThree">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      What is the Hyfye Minis Ecosystem?
                    </a>
                  </h6>
                </div>
                <div id="collapseThree" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    Hyfye Minis are modular dApps designed for micro-earning. Categories include fitness, finance, NFTs, gaming, learning, and wellness — all powered by HYE tokens.
                  </div>
                </div>
              </div>

              {/* 4 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingFour">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                      Is Hyfye a decentralized finance (DeFi) platform?
                    </a>
                  </h6>
                </div>
                <div id="collapseFour" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    Yes, Hyfye leverages decentralized blockchain technology, ensuring transparency, user ownership, and security. Governance and staking features will be added in future phases.
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingFive">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                      What is the total supply and utility of HYE tokens?
                    </a>
                  </h6>
                </div>
                <div id="collapseFive" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    HYE has a fixed total supply of 1 trillion tokens. It is used for tipping, earning, trading services, accessing premium features, and participating in community governance.
                  </div>
                </div>
              </div>

              {/* 6 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingSix">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                      How does Hyfye compare to traditional crypto projects?
                    </a>
                  </h6>
                </div>
                <div id="collapseSix" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    Hyfye is utility-first, focused on real-life use cases and micro-actions. Unlike many tokens, HYE creates passive income through simple actions, not just trading.
                  </div>
                </div>
              </div>

              {/* 7 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingSeven">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                      What platforms support Hyfye wallets?
                    </a>
                  </h6>
                </div>
                <div id="collapseSeven" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    HYE tokens are BEP-20 based and can be stored in MetaMask, Trust Wallet, SafePal, and other BNB-compatible wallets.
                  </div>
                </div>
              </div>

              {/* 8 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingEight">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                      Where can I buy HYE tokens?
                    </a>
                  </h6>
                </div>
                <div id="collapseEight" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    During the presale, you can buy HYE on PinkSale using BNB or USDT. After launch, HYE will be listed on various decentralized and centralized exchanges.
                  </div>
                </div>
              </div>

           {/* 9 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingTen">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                      How can I contact the Hyfye team?
                    </a>
                  </h6>
                </div>
                <div id="collapseTen" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    Contact us through the form at <a href="https://hyfye.com/#contact" target="_blank" rel="noopener noreferrer">hyfye.com/#contact</a> or email <a href="mailto:hi@hyfye.com">hi@hyfye.com</a>.
                  </div>
                </div>
              </div>

              {/* 10 */}
              <div className="card animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <div className="card-header" id="headingEleven">
                  <h6 className="mb-0">
                    <a className="collapsed" data-toggle="collapse" href="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                      How will I receive Hyfye tokens?
                    </a>
                  </h6>
                </div>
                <div id="collapseEleven" className="collapse" data-parent="#accordion">
                  <div className="card-body">
                    Your HYE tokens are transferred instantly to your wallet after purchase. To view them, add HYE as a custom BEP-20 token in MetaMask, Trust Wallet, or SafePal.
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQHyfye;
